import { History } from "lucide-react";

// Info/saran saja: siapa pun tetap boleh mengambil pekerjaan.
export const historyText = (h) => !h?.designer_name ? "" : `Pernah Ditangani ${h.designer_name} · `
  + (h.designers > 1 ? `${h.designer_count} dari ${h.total_orders} pesanan` : `${h.total_orders} pesanan sebelumnya`);

export function DesignerHistoryChip({ history, testid }) {
  const text = historyText(history);
  if (!text) return null;
  return <span className="dh-chip" data-testid={testid}
    title="Pelanggan lama — saran desainer berdasarkan mockup yang sudah FIX. Desainer lain tetap boleh mengambil.">
    <History size={11} aria-hidden="true"/>{text}</span>;
}
